var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microsoft"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "yeloow",
    x: 17,
    y: 17,
    width: 10,
    height: 10,
    fill: "#FEBA08"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "blue",
    x: 5,
    y: 17,
    width: 10,
    height: 10,
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "green",
    x: 17,
    y: 5,
    width: 10,
    height: 10,
    fill: "#80BC06"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "red",
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    fill: "#F25325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.b7740e735ff7dc4c79b65363eb270963.svg";
export { ForwardRef as ReactComponent };